//setting up redux store
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
    authReducer,
    regReducer,
    verifyReducer,
    forgotPasswordReducer,
    resetReducer,
    userLocationReducer,
    refreshTokenReducer,
} from './reducers/authReducer';
import { profileReducer } from './reducers/profileReducer';
import { productReducer } from './reducers/productReducer';
import { wishReducer } from './reducers/wishReducer';
import { storeReducer } from './reducers/storeReducer';
import { walletReducer } from './reducers/walletReducer';
import currencyReducer from './reducers/currencyReducer';
import { orderReducer } from './reducers/orderReducer';
import { storefrontReducer } from './reducers/storefrontReducer';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['verifyReducer', 'productReducer', 'currencyReducer'],
};

const rootReducer = combineReducers({
    storeReducer,
    wishReducer,
    authReducer,
    regReducer,
    verifyReducer,
    forgotPasswordReducer,
    resetReducer,
    refreshTokenReducer,
    userLocationReducer,
    profileReducer,
    productReducer,
    walletReducer,
    orderReducer,
    storefrontReducer,
    currencyReducer,
});

export default persistReducer(persistConfig, rootReducer);
